// extracted by mini-css-extract-plugin
export default {"accordion-list":"Q&A_accordion-list__-6nHK","qna":"Q&A_qna__RrhCa","title":"Q&A_title__c7yx3"};